/**
 * Copy a string to the clipboard. Uses navigator.clipboard when available,
 * with a fallback for older or insecure contexts.
 * @param {string} text - Plain text or URL to copy.
 * @returns {Promise<boolean>} - True if copy succeeded, false otherwise.
 */
export const copyToClipboard = async (text) => {
  if (typeof text !== "string" || !text.trim()) {
    return false;
  }
  try {
    if (typeof navigator !== "undefined" && navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
    // Fallback for older browsers or non-HTTPS
    const textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.style.position = "fixed";
    textArea.style.left = "-9999px";
    textArea.style.top = "0";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(textArea);
    return !!ok;
  } catch (err) {
    console.warn("[AI Assistant] copyToClipboard failed", err);
    return false;
  }
};
